<template>
  <section id="formulario" class="bg-gray-100 py-12" >

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700">

      <div class="container mx-auto px-4 max-w-7xl">

        <h1 class="font-bold text-gray-800 mb-4">Por favor complete el formulario en su totalidad</h1>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div class="w-full px-2 md:w-1/5">
            <label class="block mb-1">DNI / Pasaporte</label>
            <Field name="dni" v-slot="{ field }" v-model="formData.dni">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="DNI / Pasaporte"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="dni" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Nombre"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Apellido"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Empresa / Profesional</label>
            <Field name="empresa" v-slot="{ field }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Empresa"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/5">
            <label class="block mb-1">CUIT / Matrícula</label>
            <Field name="cuit" v-slot="{ field }" v-model="formData.cuit">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="CUIT / Matrícula"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cuit" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Cargo</label>
            <Field name="cargo" v-slot="{ handleChange, handleBlur, value }" v-model="formData.cargo">
              <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione el cargo" class="w-full md:w-14rem p-inputtext-sm" :options="cargos" optionLabel="descripcion"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
            </Field>            
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/3">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" class="w-full p-inputtext-sm p-3"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/3">
            <label class="block mb-1">Sitio web (corporativo)</label>
            <Field name="website" v-slot="{ field }" v-model="formData.website">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Sitio web"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="website" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/3">
            <label class="block mb-1">Instragram / Facebook</label>
            <Field name="instagramFacebook" v-slot="{ field }" v-model="formData.instagramFacebook">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Instragram / Facebook"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="instagramFacebook" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
              <label class="block mb-1">País</label>
              <Dropdown v-model="selectedCountry" filter :options="paises" optionLabel="value" placeholder="Select a Country" class="w-full md:w-14rem p-inputtext-sm"/>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.code" class="w-full p-inputtext-sm p-3" readonly />
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Teléfono comercial</label>
            <Field name="telefonoComercial" v-slot="{ field }" v-model="formData.telefonoComercial">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefonoComercial" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Teléfono celular</label>
            <Field name="telefonoCelular" v-slot="{ field }" v-model="formData.telefonoCelular">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefonoCelular" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/3">
            <label class="block mb-1">Provincia</label>
            <Field name="provincia" v-slot="{ field }" v-model="formData.provincia">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Provincia"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="provincia" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/3">
            <label class="block mb-1">Domicilio comercial</label>
            <Field name="domicilioComercial" v-slot="{ field }" v-model="formData.domicilioComercial">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Domicilio comercial"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="domicilioComercial" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Rubro</label>
            <Field name="rubro" v-slot="{ handleChange, handleBlur, value }" v-model="formData.rubro">
              <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione el rubro" class="w-full md:w-14rem p-inputtext-sm" :options="rubros" optionLabel="descripcion"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="rubro" /></span>
            </Field>            
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">¿Cómo conoció FIMAR?</label>
            <Field name="tipoContacto" v-slot="{ handleChange, handleBlur, value }" v-model="formData.tipoContacto">
              <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione como nos conoció" class="w-full md:w-14rem p-inputtext-sm" :options="tiposContactos" optionLabel="descripcion"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="tipoContacto" /></span>
            </Field>            
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">¿Que expo viene a visitar?</label>
            <Field name="expoVisita" v-slot="{ handleChange, handleBlur, value }" v-model="formData.expoVisita">
              <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione la expo que viene a visitar" class="w-full md:w-14rem p-inputtext-sm" :options="expos" optionLabel="descripcion"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="expoVisita" /></span>
            </Field>            
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">¿Visitará el Salón del Mueble Argentino?</label>
            <Field name="visitaSalonMueble" v-slot="{ handleChange, handleBlur, value }" v-model="formData.visitaSalonMueble">
              <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione si visita el salón del mueble" class="w-full md:w-14rem p-inputtext-sm" :options="siNo" optionLabel="descripcion"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="visitaSalonMueble" /></span>
            </Field>            
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 ">
            <label class="block mb-1">¿A qué expositor viene a vistar en la expo?</label>
            <Field name="expositorVisita" v-slot="{ field }" v-model="formData.expositorVisita">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Ingrese a que expositor viene a visitar"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="expositorVisita" /></span>
            </Field>
          </div>
        </div>


        <!--div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Esepcifique el rubro</label>
            <Field name="otroRubro" v-slot="{ field }" v-model="formData.otroRubro">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm" :disabled="formData.rubro?.id !== 9" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="otroRubro" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Especifique cómo nos conoció</label>
            <Field name="otroTipoContacto" v-slot="{ field }" v-model="formData.otroTipoContacto">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm" :disabled="formData.tipoContacto === undefined || formData.tipoContacto.id !== 5" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="otroTipoContacto" /></span>
            </Field>
          </div>
        </div-->

        <h1 class="font-bold text-gray-800 mb-4 md:mt-5">Algunos datos sobre su comercio</h1>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/4">
            <label class="block mb-1">¿Tiene showroom?</label>
            <Field name="tieneShowroom" v-slot="{ handleChange, handleBlur, value }" v-model="formData.tieneShowroom">
              <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione una opción" class="w-full md:w-14rem p-inputtext-sm" :options="siNo" optionLabel="descripcion"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="tieneShowroom" /></span>
            </Field>            
          </div>
          <div class="w-full px-2 md:w-1/4">
            <label class="block mb-1">¿Vende por e-commerce?</label>
            <Field name="vendePorEcommerce" v-slot="{ handleChange, handleBlur, value }" v-model="formData.vendePorEcommerce">
              <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione una opción" class="w-full md:w-14rem p-inputtext-sm" :options="siNo" optionLabel="descripcion"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="vendePorEcommerce" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/4">
            <label class="block mb-1">¿Tiene sucursales?</label>
            <Field name="tieneSucursales" v-slot="{ handleChange, handleBlur, value }" v-model="formData.tieneSucursales">
              <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione una opción" class="w-full md:w-14rem p-inputtext-sm" :options="siNo" optionLabel="descripcion"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="tieneSucursales" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/4">
            <label class="block mb-1">¿Pertenece a una red u organización?</label>
            <Field name="perteneceRed" v-slot="{ handleChange, handleBlur, value }" v-model="formData.perteneceRed">
              <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione una opción" class="w-full md:w-14rem p-inputtext-sm" :options="siNo" optionLabel="descripcion"/>
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="perteneceRed" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2" v-show="formData.tieneSucursales != undefined && formData.tieneSucursales.id === 1">
            <label class="block mb-1">Especifique cuantas sucursales tiene</label>
            <Field name="cantidadSucursales" v-slot="{ field }" v-model="formData.cantidadSucursales">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cantidadSucursales" /></span>
            </Field>
          </div>
        
          <div class="w-full px-2 md:w-1/2" v-show="formData.perteneceRed != undefined && formData.perteneceRed.id === 1">
            <label class="block mb-1">¿Cuál es el nombre de la organización a la que pertenece?</label>
            <Field name="nombreRed" v-slot="{ field }" v-model="formData.nombreRed">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombreRed" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit" label="REGISTRARME" class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>REGISTRARME
          </button>
        </div>

      </div>
    </Form>

  </section>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';

import jsonCountries from '@/data/countries.json';
import jsonExpos from '@/data/expos.json';
import jsonCargos from '@/data/cargos.json';
import jsonRubros from '@/data/rubros.json';
import jsonTiposContacto from '@/data/tiposContacto.json';
import jsonSiNo from '@/data/sino.json';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, IdLabelEntity, OrigenAcreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { SAVE, ORIGEN_ACREDITADO, VERIFICADO } from "qreventos-suite/constantes";

interface Pais {
  code: string;
  value: string;
}

interface Cargo extends IdLabelEntity {}
interface ExpoVisita extends IdLabelEntity {}
interface Rubro extends IdLabelEntity {}
interface TipoContacto extends IdLabelEntity {}
interface SiNo extends IdLabelEntity {}

export default defineComponent({
  name: 'FormSection',
  components: {
    InputText, Dropdown,  
    Field, ErrorMessage, Form
  },
  data() {
    return {
      paises: [] as Pais[],
      selectedCountry: {"code": "+54", "value": "Argentina"} as Pais,
      isSubmitting: false,
      cargos: [] as Cargo[],
      rubros: [] as Rubro[],
      expos: [] as ExpoVisita[],
      tiposContactos: [] as TipoContacto[],
      siNo: [] as SiNo[],
      formData: {
        dni:  '',
        nombre: '',
        apellido: '',
        empresa: '',
        cuit: '',
        telefonoComercial: '',
        telefonoCelular: '',
        mail: '',
        website: '',
        instagramFacebook: '',
        provincia: '',
        domicilioComercial: '',
        cargo: undefined as unknown as Cargo,
        rubro: undefined as unknown as Rubro,
        otroRubro: '',
        tieneShowroom: undefined as unknown as SiNo,
        vendePorEcommerce: undefined as unknown as SiNo,
        tieneSucursales: undefined as unknown as SiNo,
        cantidadSucursales: '',
        perteneceRed: undefined as unknown as SiNo,
        nombreRed: '',
        tipoContacto: undefined as unknown as TipoContacto,
        otroTipoContacto: '',
        expositorVisita: '',        
        expoVisita: undefined as unknown as ExpoVisita,
        visitaSalonMueble: undefined as unknown as SiNo,
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        dni: yup.string().required('Ingrese el DNI').min(8, 'Al menos 8 números'),
        nombre: yup.string().required('Ingrese el nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese el apellido').min(3, 'Al menos 3 letras'),
        mail: yup.string().required('Ingrese el correo').email('Correo inválido'),
        empresa: yup.string().required('Ingrese la empresa').min(2, 'Al menos 3 letras'),
        cuit: yup.string().required('Ingrese el CUIT').min(8, 'Al menos 8 letras'),
//        website: yup.string().required('Ingrese la web').min(10, 'Mínimo 10 letras').matches(/^(http:\/\/|https:\/\/)/, 'La web debe comenzar con "http://" o "https://"'),
        instagramFacebook: yup.string().required('Ingrese el Instragram o Facebook').min(5, 'Mínimo 5 letras'),
        telefonoComercial: yup.string().required('Ingrese el teléfono').matches(/^\d+$/, 'Solo se permiten números'),
        telefonoCelular: yup.string().required('Ingrese el celular').matches(/^\d+$/, 'Solo se permiten números'),
        provincia: yup.string().required('Ingrese la provincia').min(4, 'Al menos 4 letras'),
        domicilioComercial: yup.string().required('Ingrese el domicilio comercial').min(4, 'Al menos 4 letras'),
        cargo: yup.mixed().required('Seleccione el cargo'),
        rubro: yup.mixed().required('Seleccione el rubro'),
        visitaSalonMueble: yup.mixed().required('Seleccione si visita el salón'),
        //tipoContacto: yup.mixed().required('Seleccione como nos conoció'),
        //tieneShowroom: yup.mixed().required('Seleccione si tiene showroom'),
        //vendePorEcommerce: yup.mixed().required('Seleccione si tiene e-commerce'),
        //tieneSucursales: yup.mixed().required('Seleccione si tiene sucursales'),
        //perteneceRed: yup.mixed().required('Seleccione si pertenece a una red'),
        otroRubro: yup.string().test('validacion-otro-rubro', 'Debes ingresar el rubro o seleccionar uno de la lista', function(value) {
          const rubroSelected = this.parent.rubro;
          if(rubroSelected?.id === 9 && !value) {
              return false;
          }
          return true;
        }),
        otroTipoContacto: yup.string().test('validacion-otro-tipo-contacto', 'Debes ingresar como nos conoció o seleccionar de la lista', function(value) {
          const tipoContactoSelected = this.parent.tipoContacto;
          if(tipoContactoSelected?.id === 5 && !value) {
              return false;
          }
          return true;
        }),
        cantidadSucursales: yup.string().test('validacion-otro-cantidad', 'Debes ingresar la cantidad de sucursales', function(value) {
          const tieneSucursalesSelected = this.parent.tieneSucursales;
          if(tieneSucursalesSelected?.id === 1 && !value) {
              return false;
          }
          return true;
        }),
        nombreRed: yup.string().test('validacion-otro-tipo-contacto', 'Debes ingresar el nombre de la red a la que pertenece', function(value) {
          const perteneceRedSelected = this.parent.perteneceRed;
          if(perteneceRedSelected?.id === 1 && !value) {
              return false;
          }
          return true;
        }),
      });
    }
  },
  watch: {
    'formData.rubro.id'(newValue) {
      if (newValue !== 9) {
        this.formData.otroRubro = '';
      }
    },
    'formData.tipoContacto.id'(newValue) {
      if (newValue !== 5) {
        this.formData.otroTipoContacto = '';
      }
    },
    'formData.tieneSucursales.id'(newValue) {
      if (newValue !== 2) {
        this.formData.cantidadSucursales = '';
      }
    },
    'formData.perteneceRed.id'(newValue) {
      if (newValue !== 2) {
        this.formData.nombreRed = '';
      }
    },
  },
  methods: {
    async onSubmit() {
      this.isSubmitting = true;

      let acreditado:Acreditado = new Object() as Acreditado;
      acreditado.tipoAcreditado = { "id": 522 } as TipoAcreditado;
      acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
      acreditado.dni = this.formData.dni;
      acreditado.nombre = this.formData.nombre;
      acreditado.apellido = this.formData.apellido;
      acreditado.empresa = this.formData.empresa;
      acreditado.telefono = this.selectedCountry.code + this.formData.telefonoCelular;
      acreditado.mail = this.formData.mail;
      acreditado.cargo = this.formData.cargo.descripcion;
      acreditado.origenAcreditado = { "id" : ORIGEN_ACREDITADO } as OrigenAcreditado;
      acreditado.modificado = SAVE; // SAVE
      acreditado.cantidad = 1;
      acreditado.notificar = true;
      
      acreditado.datos = {} as any;
      acreditado.datos["2584"] = this.formData.cuit;      
      acreditado.datos["2582"] = this.selectedCountry.code + this.formData.telefonoComercial;
      acreditado.datos["2583"] = this.formData.website;
      acreditado.datos["2585"] = this.formData.instagramFacebook;
      acreditado.datos["2586"] = this.selectedCountry.value;
      acreditado.datos["2587"] = this.formData.provincia;
      acreditado.datos["2588"] = this.formData.domicilioComercial;
      acreditado.datos["2589"] = this.formData.rubro.descripcion;
      acreditado.datos["2596"] = this.formData.otroRubro;

      acreditado.datos["2598"] = this.formData.tipoContacto?.descripcion;
      acreditado.datos["2590"] = this.formData.tieneShowroom?.descripcion;
      acreditado.datos["2591"] = this.formData.vendePorEcommerce?.descripcion;
      acreditado.datos["2592"] = this.formData.tieneSucursales?.descripcion;
      acreditado.datos["2594"] = this.formData.perteneceRed?.descripcion;

      acreditado.datos["2593"] = this.formData.cantidadSucursales;
      acreditado.datos["2595"] = this.formData.nombreRed;
      acreditado.datos["2597"] = this.formData.otroTipoContacto;

      acreditado.datos["3987"] = this.formData.expositorVisita;
      acreditado.datos["4442"] = this.formData.visitaSalonMueble?.descripcion;
      acreditado.datos["4095"] = this.formData.expoVisita?.descripcion;

      try {
        await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);
        
        Swal.fire({
            title: "Acreditación exitosa",
            html: "Hemos recibido sus datos de acreditación con éxito.<br/>Le enviamos un código QR al mail indicado para agilizar su ingreso al evento. <br/><br/>Si tiene problemas para recibir el correo puede presentarse con sun DNI.",
            icon: "success",
        }).then(() => {
          window.location.href = "https://fimar.com.ar";
        });

      } catch(error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
    this.expos = jsonExpos;
    this.paises = jsonCountries;
    this.cargos = jsonCargos;
    this.rubros = jsonRubros;
    this.tiposContactos = jsonTiposContacto;
    this.siNo = jsonSiNo;  
  }
});
</script>
